var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 224,
    viewBox: "0 0 274 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_825)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10_825)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-34.6921 199.101C3.24692 288.538 168.767 341.017 211.961 268.52C255.155 196.023 145.862 182.867 107.226 107.951C68.5909 33.0349 38.5692 -13.7231 -17.2556 3.34429C-73.0804 20.4117 -72.6312 109.664 -34.6921 199.101Z",
    fill: "#6259FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.095 257.153C297.774 228.875 329.934 113.627 278.97 85.6246C228.005 57.6223 221.573 133.204 170.911 161.612C120.249 190.02 88.771 211.819 101.867 249.853C114.963 287.887 176.416 285.431 237.095 257.153Z",
    fill: "#F9818E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.305 125.097L175.912 114.291",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.461 130.581L196.955 120.078",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56 144.991L180.652 159.789",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 202.891C37.3078 202.891 67.3047 172.894 67.3047 135.891C67.3047 98.8876 37.3078 68.8907 0.304688 68.8907C-36.6984 68.8907 -66.6953 98.8876 -66.6953 135.891C-66.6953 172.894 -36.6984 202.891 0.304688 202.891Z",
    fill: "#FFAF7E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 224,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 393,
    fill: "white",
    transform: "translate(-90 -44)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvals);
export default __webpack_public_path__ + "static/media/ovals.0f1038d7f08017708cd748b1f27e4be6.svg";
export { ForwardRef as ReactComponent };